import type { FC } from 'react'

import { marquee } from '@/constants/content'

export const Marquee: FC = () => {
    const items = [...marquee, ...marquee]

    return (
        <div className='relative z-10 overflow-hidden border-y border-white/[0.07] bg-brand py-4 text-brand-foreground'>
            <p className='sr-only'>
                {marquee.join(', ')}
            </p>
            <div aria-hidden='true' className='flex w-max animate-marquee whitespace-nowrap'>
                {items.map((item, index) => (
                    <span key={`${item}-${index}`} className='flex items-center gap-10 pr-10 font-heading font-expanded text-lg font-extrabold uppercase tracking-tight sm:text-xl'>
                        {item}
                        <svg viewBox='0 0 12 12' className='size-3 fill-current opacity-70'>
                            <path d="M6 0l1.6 4.4L12 6 7.6 7.6 6 12 4.4 7.6 0 6l4.4-1.6z" />
                        </svg>
                    </span>
                ))}
            </div>
        </div>
    )
}
